
import { defineComponent, ref, reactive, watch, toRefs, nextTick } from 'vue';
import downloadBtn from '../../components/downloadBtn.vue';

export default defineComponent({
  components: {
    downloadBtn
  },
  props: {
    swiperIndex: {
      type: Number,
      default: 6
    }
  },
  setup(props) {
    const isAppshow = ref(false);
    const isAndShow = ref(false);
    const data = reactive({
      nowPage: 6
    });
    const endPageRef = ref();
    watch(
      () => props.swiperIndex,
      (newVla) => {
        data.nowPage = Number(newVla);
        // 监听页面高度
        nextTick(() => {
          if (data.nowPage !== 6) {
            endPageRef.value!.scrollTop = 0 + 'px';
          }
        });
      }
    );
    //展示二维码
    const showEwm = (e: number) => {
      if (e == 1) {
        isAppshow.value = true;
      } else if (e == 2) {
        isAndShow.value = true;
      }
    };
    //关闭二维码
    const closeEwm = (e: number) => {
      if (e == 1) {
        isAppshow.value = false;
      } else if (e == 2) {
        isAndShow.value = false;
      }
    };

    return {
      showEwm,
      closeEwm,
      isAndShow,
      isAppshow,
      endPageRef,
      ...toRefs(data)
    };
  }
});
